import styled from 'styled-components';
import { fonts } from 'stylesheets';

export const RatingContainer = styled.div`
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
  padding-bottom: 20px;
  p, span {
    font-family: ${fonts.primary};
  }
`;

export const UserRating = styled.div`
  display: flex;
`;

export const UserAvatar = styled.img`
  width: 43px;
  height: 43px;
  background: grey;
  border-radius: 100%;
  margin: 2px 15px 0 0;
`;

export const UserName = styled.span`
  font-weight: 500;
  font-size: 15px;
`;

export const RatingInfos = styled.div`
  img {
    margin-top: -10px;
  }
`;

export const RatingDate = styled.p`
  font-size: 13px;
  margin-top: 8px;
  float: right;
`;

export const RatingText = styled.p`
  text-align: justify !important;
  margin-top: 10px;
`;
